import React, { useState } from 'react';
import axios from 'axios';
import './Login.css'; // Optional, keep it if you have custom styles
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [userid, setUserid] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');

  const api = process.env.REACT_APP_API;
  const apikey = process.env.REACT_APP_KEY;
  const navi=useNavigate()
const handleSubmit = async (e) => {
  e.preventDefault();
  setError(''); // Clear previous errors

  const sendData = {
    userid,
    password,
  };

  try {
    const response = await axios.post(
      `${api}/Admin/login`,
      sendData,
      {
        headers: {
          'Content-Type': 'application/json',
          'apikey': apikey,
        },
      }
    );

    console.log(response.data);

    if (response.data.status === true) {
      alert('Login successful!');
      navi("/dashboard");
      localStorage.setItem('role', response.data.data.role);
      localStorage.setItem('userid', response.data.user.userid);
    } else {
      // Show backend error message
      setError(response.data.message || 'Login failed');
    }

  } catch (err) {
    console.error('Login error:', err);

    // Use backend error message if available
    if (err.response?.data?.message) {
      setError(err.response.data.message);
    } else {
      setError('Server error. Please try again.');
    }
  }
};

  return (
    <div className="container-scroller">
      <div className="container-fluid page-body-wrapper full-page-wrapper">
        <div className="content-wrapper d-flex align-items-center auth px-0">
          <div className="row w-100 mx-0">
            <div className="col-lg-4 mx-auto">
              <div className="auth-form-light text-left py-5 px-4 px-sm-5">
                
                <div className="brand-logo text-center mb-3">
                  <img src={`${process.env.PUBLIC_URL}/logo192.png`} alt="logo" style={{ width: 100, height: 100 }} />
                </div>

                <h4>Hello! let's get started</h4>
                <h6 className="font-weight-light">Sign in to continue.</h6>

                {error && <div className="alert alert-danger mt-2">{error}</div>}

                <form className="pt-3" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      placeholder="Username"
                      value={userid}
                      onChange={(e) => setUserid(e.target.value)}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <div className="position-relative">
                      <input
                        type={showPassword ? 'text' : 'password'}
                        className="form-control form-control-lg"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                      <span
                        onClick={() => setShowPassword(!showPassword)}
                        style={{
                          position: 'absolute',
                          right: '10px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          cursor: 'pointer',
                        }}
                      >
                        {showPassword ? '🙈' : '👁️'}
                      </span>
                    </div>
                  </div>

                  <div className="mt-3">
                    <button
                      type="submit"
                      className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                    >
                      SIGN IN
                    </button>
                  </div>

                  <div className="my-2 d-flex justify-content-between align-items-center">
                    {/* <div className="form-check">
                      <label className="form-check-label text-muted">
                        <input type="checkbox" className="form-check-input" />
                        Keep me signed in
                      </label>
                    </div> */}
                    <a href="#" className="auth-link text-black">Forgot password?</a>
                  </div>

                  {/* <div className="mb-2">
                    <button
                      type="button"
                      className="btn btn-block btn-facebook auth-form-btn"
                    >
                      <i className="ti-facebook me-2"></i>
                      Connect using Facebook
                    </button>
                  </div> */}

                  <div className="text-center mt-4 font-weight-light">
                    Don't have an account?{' '}
                    <a href="#" className="text-primary">Create</a>
                  </div>
                </form>

              </div>
            </div>
          </div>
        </div>
        {/* content-wrapper ends */}
      </div>
      {/* page-body-wrapper ends */}
    </div>
  );
};

export default Login;



// // src/components/Login.jsx
// import React, { useState } from 'react';
// import axios from 'axios';
// import './Login.css';

// const Login = () => {
//   const [userid, setUserid] = useState('');
//   const [password, setPassword] = useState('');
//   const [showPassword, setShowPassword] = useState(false);
//   const [error, setError] = useState('');

//   const api = process.env.REACT_APP_API;
//   const apikey = process.env.REACT_APP_KEY;

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError('');

//     const sendData = {
//       userid,
//       password,
//     };

//     try {
//       const response = await axios.post(
//         `${api}/Admin/login`,
//         sendData,
//         {
//           headers: {
//             'Content-Type': 'application/json',
//             'apikey': apikey,
//           },
//         }
//       );

//       if (response.data.status === true) {
//         alert('Login successful!');
//         // You could store a token or redirect here
//       } else {
//         setError('Invalid credentials');
//       }
//     } catch (err) {
//       console.error('Login error:', err);
//       if (err.response?.status === 401) {
//         setError('Invalid credentials');
//       } else {
//         setError('Server error. Please try again.');
//       }
//     }
//   };

//   return (
//     <div className="login-container">
//       <form className="login-form" onSubmit={handleSubmit}>
//         <h2>Welcome Back 👋</h2>
//         <p>Please login to your account</p>

//         {error && <div className="error-msg">{error}</div>}

//         <div className="input-group">
//           <label>User ID</label>
//           <input
//             type="text"
//             placeholder="User ID"
//             value={userid}
//             onChange={(e) => setUserid(e.target.value)}
//             required
//           />
//         </div>

//         <div className="input-group">
//           <label>Password</label>
//           <div className="password-wrapper">
//             <input
//               type={showPassword ? "text" : "password"}
//               placeholder="Enter your password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               required
//             />
//             <span
//               className="toggle-password"
//               onClick={() => setShowPassword(!showPassword)}
//             >
//               {showPassword ? '🙈' : '👁️'}
//             </span>
//           </div>
//         </div>

//         <button type="submit" className="login-btn">Login</button>

//         <div className="register-link">
//           Don't have an account? <a href="#">Register</a>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default Login;
